const MappaLinks = () => {
    const select = document.getElementById('regioni-select');
    if (!select) return;
    const button = document.getElementById('regioni-btn');
    
    // Abilita/disabilita il pulsante in base alla selezione
    select.addEventListener('change', function() {
        const selectedValue = this.value;
        button.disabled = !selectedValue;
        
        // Evidenzia la regione sulla mappa
        const regionId = this.options[this.selectedIndex].dataset.region;
        highlightRegion(regionId);
    });
    
    // Gestisce il click del pulsante
    button.addEventListener('click', function() {
        const selectedValue = select.value;
        if (selectedValue) {
            window.open(selectedValue, '_blank');
        }
    });
    
    // Funzione per evidenziare la regione sulla mappa
    function highlightRegion(regionId) {
        // Rimuovi evidenziazione precedente da path e group
        document.querySelectorAll('#mappa-italia path').forEach(path => {
            path.classList.remove('region-highlighted');
        });
        document.querySelectorAll('#mappa-italia g').forEach(group => {
            group.classList.remove('region-highlighted');
        });
        
        // Evidenzia la regione selezionata (path)
        if (regionId) {
            const regionPath = document.querySelector('#mappa-italia path[id="' + regionId + '"]');
            if (regionPath) {
                regionPath.classList.add('region-highlighted');
            }
            // Evidenzia la regione selezionata (group)
            const regionGroup = document.querySelector('#mappa-italia g[id="' + regionId + '"]');
            if (regionGroup) {
                regionGroup.classList.add('region-highlighted');
            }
        }
    }
}
export default MappaLinks;